// Computes a hex-encoded HMAC-SHA256 signature over a JSON payload, used to
// sign requests for the Member MRN integration API (x-hmac-signature header).
// For bodyless requests (e.g. GET), call with no payload — it signs "{}" to
// match the integration spec.
export async function signHmacSha256(secretKey, payload = {}) {
  const message = JSON.stringify(payload);
  const encoder = new TextEncoder();
  const key = await window.crypto.subtle.importKey(
    "raw",
    encoder.encode(secretKey),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signatureBuffer = await window.crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(message)
  );
  return Array.from(new Uint8Array(signatureBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
